const { PROMOTION_TYPE } = require('./promotion');

module.exports = {
    promotionTypeTitle(promotionTypeId) {
        switch(promotionTypeId) {
            case PROMOTION_TYPE.DISCOUNT: return 'Скидка';
            // case PROMOTION_TYPE.GIFT: return 'Подарок';
        }
        return '???';
    },
}
